import { formatUtcDateToDDMMYYYY, parseDDMMYYYYToEpoch } from 'src/app/project/shared/date-utils';

export function getTimeframeIndex(formattedTimeframes: string[], value: number): number {
  const searchedDateEpoch = parseDDMMYYYYToEpoch(formatUtcDateToDDMMYYYY(new Date(value)));

  return formattedTimeframes.findIndex(
    (_timeframe) => searchedDateEpoch <= parseDDMMYYYYToEpoch(_timeframe),
  );
}
